import React from 'react';
import Compiler from '../compiler/Compiler';

const KovAttachments = ({ item }) => {
  throw new Error('This component is not refactored yet');

  return (
    <ul className="kov-pro-references">
      {(item?.items || item?.children)?.map((attachment, i) => (
        <li key={i} className="download">
          <a target="_blank" rel="noreferrer" download="true" href={attachment.attachment.href}>
            <Compiler text={attachment.description} />
          </a>
          <a>
            {/* <span>{ctrl.getAttachmentType(attachment.attachment.contentType).type}</span> */}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default KovAttachments;
